import React from 'react';

import './WidgetNotAvailable.scss';
import { useWidgetContext } from 'widgets/WidgetContext';

export interface WidgetNotAvailableProps {
    className: string;
    title: string;
}

export function WidgetNotAvailable(props: WidgetNotAvailableProps) {
    const { widgetKey } = useWidgetContext();
    const { title, className } = props;

    return (
        <div
            className={`WidgetNotAvailable ${className}`}
            data-widget-id={widgetKey}
        >
            <div className="title">{title}</div>
        </div>
    );
}
